module.exports = __webpack_public_path__ + "img/ic_32_sport_handball-white.8330976c.svg";